import { Outlet } from "react-router-dom";

const InmobiliariasThemeWrapper = () => (
  <div className="sozu-theme">
    <Outlet />
  </div>
);

export default InmobiliariasThemeWrapper;
